import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchTppAccessSummary, fetchTppPoolSettings } from '../../../services/transitPassPool.service';

/** 接続後に必要なプール要約・設定 */
export function useTppPoolQueries(zipConnected: boolean) {
  const [poolKey, setPoolKey] = useState('default');

  const accessQuery = useQuery({
    queryKey: ['tpp-access-summary', zipConnected],
    queryFn: fetchTppAccessSummary,
    enabled: zipConnected,
  });

  const settingsQuery = useQuery({
    queryKey: ['tpp-pool-settings', poolKey],
    queryFn: () => fetchTppPoolSettings(poolKey),
    enabled: zipConnected,
  });

  useEffect(() => {
    const pk = settingsQuery.data?.poolKey;
    if (pk && pk !== poolKey) {
      setPoolKey(pk);
    }
  }, [settingsQuery.data, poolKey]);

  return { poolKey, accessQuery, settingsQuery };
}
